<app-sidebar></app-sidebar>
<div class="shell" [class.shell--sidebar-collapsed]="layout.collapsed()">
  <app-topbar></app-topbar>
  <main class="shell__content">
    <router-outlet></router-outlet>
  </main>
</div>
